import { formatAddress } from './formatAddress'
import { getPostalAddressLines, type PostalAddress } from './getPostalAddressLines'

export const getPostalAddress = (address: PostalAddress): string | null =>
  formatAddress(getPostalAddressLines(address)) || null
